// ==============================|| OVERRIDES - LINK ||============================== //

export default function Link() {
  return {
    MuiLink: {
      defaultProps: {
        underline: 'always'
      },
      styleOverrides: {
        root: {
          color: 'var(--nv-text-primary)',
          textDecorationColor: 'currentColor',
          '&:hover': { color: 'var(--nv-brand-on-soft)' }
        }
      }
    }
  };
}
